module.exports = __webpack_public_path__ + "static/media/green_badge.a796e65f.svg";